// Gộp các file JSON theo màn hình (src/locales/<lng>/<screen>.json) thành 1 resource cho mỗi ngôn ngữ.
// Thêm màn hình mới = thêm file <screen>.json vào từng thư mục ngôn ngữ, không cần sửa file này.
export const SUPPORTED_LANGUAGES = ["en", "vi", "zh", "ru", "ar"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

/** Ngôn ngữ viết từ phải sang trái. */
export const RTL_LANGUAGES: readonly string[] = ["ar"];

type Dict = { [key: string]: string | Dict };

const isDict = (v: unknown): v is Dict => typeof v === "object" && v !== null;

const deepMerge = (target: Dict, source: Dict): Dict => {
  Object.keys(source).forEach((key) => {
    const s = source[key];
    const t = target[key];
    target[key] = isDict(s) && isDict(t) ? deepMerge(t, s) : s;
  });
  return target;
};

const context = require.context("./", true, /^\.\/[a-z]{2}\/[a-z_]+\.json$/);

const buildResources = () => {
  const resources: Record<string, { translation: Dict }> = {};
  context.keys().forEach((file: string) => {
    const lng = file.split("/")[1];
    const dict = context(file) as Dict;
    resources[lng] = {
      translation: deepMerge(resources[lng]?.translation ?? {}, dict),
    };
  });
  return resources;
};

export const resources = buildResources();
